export enum IconSize {
    auto = 0,
    small = 1,
    medium = 2,
    large = 3,
    jumbo = 4,
    extraLarge = 5
}

export function iconSizeScale(iconSize: IconSize) {
    switch (iconSize) {
        case IconSize.auto:
            return 0.9;
        case IconSize.small:
            return 0.6;
        case IconSize.medium:
            return 0.8;
        case IconSize.large:
            return 1.0;
        case IconSize.extraLarge:
            return 1.2;
        case IconSize.jumbo:
            return 1.4;
        default:
            return 1.0;
    }
}
